module.exports = __webpack_public_path__ + "img/DESC_SORT.3b3d9645.svg";